import { PrizeType } from "@/api/model"

export const PRIZE_TYPE_DISPLAY_NAMES: Partial<Record<PrizeType, string>> = {
  YEAR_OF_ENERGY: "Year of Free Energy",
  YEAR_OF_ENERGY_LEGACY: "Year of Free Energy",
  ACCOUNT_CREDIT_10_POUNDS: "£10 Energy Credit",
  ACCOUNT_CREDIT_20_POUNDS: "£20 Energy Credit",
  ACCOUNT_CREDIT: "Energy Credit",
  EV_CHARGER: "EV charger",
  EV_CHARGER_CREDIT: "Energy Credit",
  HOMETREE: "Boiler service",
  VOUCHER: "Amazon voucher",
} as const

/** Falls back to a generic label so an unmapped prize type never renders blank. */
export const getPrizeDisplayName = (type: PrizeType): string =>
  PRIZE_TYPE_DISPLAY_NAMES[type] ?? "Prize"

/** Year of Energy is the headline ("top") prize; everything else is a standard win. */
export const isTopPrizeType = (type: PrizeType): boolean =>
  type === PrizeType.YEAR_OF_ENERGY || type === PrizeType.YEAR_OF_ENERGY_LEGACY

export const PRIZE_DRAW_COMPLETION_DATE = "2026-02-25T00:00:00.000Z"
export const PRIZE_DRAW_ENTRY_DEADLINE = "2026-02-01T00:00:00.000Z"
